var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',_vm._b({attrs:{"label":_vm.label},scopedSlots:_vm._u([(_vm.tips)?{key:"label",fn:function(){return [_vm._v("\n      "+_vm._s(_vm.label)+"\n      "),_c('icon-tips',{attrs:{"content":_vm.tips}})]},proxy:true}:null],null,true)},'el-form-item',_vm.$attrs,false),[_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }